import {
  DefaultPageLayout,
  HeadMetatags,
  Container,
} from 'routes/components/Layout'
import { BookADemoDescription } from './components/Description'
import { BookADemoCalendly } from './components/Calendly'
import classes from './BookADemo.module.scss'

export default function BookADemoPage() {
  return (
    <DefaultPageLayout hideAdvertiseBlock className={classes.page}>
      <HeadMetatags title='Schedule Demo' />
      <Container className={classes.container}>
        <BookADemoDescription />
        <BookADemoCalendly />
      </Container>
    </DefaultPageLayout>
  )
}
